import { useEffect } from "react";
import Library from "./components/Library";

import './scss/app.scss';

function App() {
  useEffect(() => {
    if (window.location.pathname.includes("/library/thieme")) {
      document.title = "Library | Synaptiq Learning | Thieme";
    } else {
      document.title = "Library | Synaptiq Learning";
    }
  }, []);

  return (
    <div className="App">
      <Library/>
    </div>
  );
}

export default App;